import { getPriceRange } from "model"
import Sorter from "../../../model/Sorter"
import { ProductType } from "model"

const PriceLowHighSorter: Sorter = {
  label: "Price Low to High",
  id: "price-low-high",
  sort: (products: ProductType[]): ProductType[] => {
    const sortedProducts = [...products]
    sortedProducts.sort((productA, productB) => {
      const a = getPriceRange(productA)[0]
      const b = getPriceRange(productB)[0]

      if (a < b) {
        return -1
      }
      if (a > b) {
        return 1
      }
      return 0
    })

    return sortedProducts
  },
}

export default PriceLowHighSorter
